import {useSelector} from "react-redux";
import {ProductModel} from "../Models/ProductModel";
import {StateModel} from "../Models/StateModel";
import {OrderModel} from "../Models/OrderModel";

export const useGetStockAvailable = (): (product?: ProductModel) => number => {
    const panier = useSelector<StateModel, OrderModel | undefined>(state => state.panier)
    return (product?: ProductModel): number => {
        if(product) {
            const panierProducts = panier?.orderProducts?.filter(p => p.product.id === product.product.id)
            if (panierProducts) {
                const quantityInPanier = panierProducts.map(p => p.quantity ?? 0).reduce((prev, curr) => prev + curr, 0)
                return product.stockAvailable - quantityInPanier
            }
            return product.stockAvailable
        }
        return 0
    }
}
